import { CFAuthPostRef } from 'auth';
import { locations } from '../../common/redux/action_locations';
import { addUiErrorAction } from './addUiError';
import {
  FETCH_CALL_DETAILS,
  RECEIVED_CALL_DETAILS,
  UI_ERROR_REFS,
} from './constants';
import { parseCallDate } from '../CallDetailsSection';

export function fetchCallDetailsAction(filters) {
  return {
    type: FETCH_CALL_DETAILS,
    fetchCall: fetchCallDetails,
    receivedAction: receivedCallDetails,
    data: {
      locations,
      filters,
    },
  };
}

function fetchCallDetails(filters) {
  return CFAuthPostRef({
    url: `${process.env.REACT_APP_COACHING_API_URL}/api/CallDetails/GetCallDetails`,
    body: {
      page: 1,
      pageSize: 1,
      sortOrder: 'asc',
      sortColumn: 'ContactID',
      filterConditions: [
        {
          operation: 'Equals',
          value: filters.callLogId,
          propertyName: 'ContactID',
        }
      ]
    },
    originURL: process.env.PUBLIC_URL,
    loaderName: 'fetchCallDetails'
  });
}

export function receivedCallDetails(data) {
  try {
    const { items: [callDetails] } = data.data;

    if (!!callDetails) {
      callDetails.callDate = parseCallDate(callDetails.callDate);
      return {
        type: RECEIVED_CALL_DETAILS,
        data: callDetails,
      };
    } else {
      return addUiErrorAction({
        errorMessage: 'Call Log ID not found.',
        errorRef: UI_ERROR_REFS.callLogIdError
      });
    }
  } catch (e) {
    return addUiErrorAction({
      errorMessage: 'Call Log ID not found.',
      errorRef: UI_ERROR_REFS.callLogIdError
    })
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case RECEIVED_CALL_DETAILS:
      return {
        ...state,
        callDetails: action.data,
        uiError: {},
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/agent-coaching/redux/fetchCallDetails.js